import React from 'react';

export default function PageLoadingSkeleton({ pageLabel = 'page' }) {
  const label = `Loading ${pageLabel}…`;

  return (
    <div
      className="fl-page-skeleton"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <span className="sr-only">{label}</span>

      <section className="fl-page-skeleton__hero" aria-hidden="true">
        <div className="container fl-page-skeleton__hero-inner">
          <div className="fl-skeleton fl-skeleton--eyebrow" />
          <div className="fl-skeleton fl-skeleton--title" />
          <div className="fl-skeleton fl-skeleton--subtitle" />
          <div className="fl-skeleton fl-skeleton--subtitle fl-skeleton--subtitle-short" />
          <div className="fl-page-skeleton__hero-actions">
            <div className="fl-skeleton fl-skeleton--btn" />
            <div className="fl-skeleton fl-skeleton--btn fl-skeleton--btn-secondary" />
          </div>
        </div>
      </section>

      <section className="fl-page-skeleton__section fl-section--alt" aria-hidden="true">
        <div className="container">
          <div className="fl-page-skeleton__section-header">
            <div className="fl-skeleton fl-skeleton--section-title" />
            <div className="fl-skeleton fl-skeleton--section-subtitle" />
          </div>
          <div className="fl-page-skeleton__cards">
            {[0, 1, 2].map((index) => (
              <div key={index} className="fl-page-skeleton__card">
                <div className="fl-skeleton fl-skeleton--icon" />
                <div className="fl-skeleton fl-skeleton--card-title" />
                <div className="fl-skeleton fl-skeleton--card-line" />
                <div className="fl-skeleton fl-skeleton--card-line fl-skeleton--card-line-short" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="fl-page-skeleton__section" aria-hidden="true">
        <div className="container fl-page-skeleton__form-wrap">
          <div className="fl-skeleton fl-skeleton--form-title" />
          <div className="fl-page-skeleton__form-grid">
            <div className="fl-skeleton fl-skeleton--input" />
            <div className="fl-skeleton fl-skeleton--input" />
            <div className="fl-skeleton fl-skeleton--input fl-page-skeleton__form-full" />
            <div className="fl-skeleton fl-skeleton--textarea" />
          </div>
          <div className="fl-skeleton fl-skeleton--submit" />
        </div>
      </section>
    </div>
  );
}
